import React, { useState } from "react";
import "../MerchantModule/styles/MerchantScreen.css"; // Base styles
import "./styles/CustomerScreen.css"; // Customer-specific styles
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { OvalLoader } from "../../Common/Loaders";
import {
  useFetchCustomerByIdQuery,
  useFetchCustomerProjectsQuery,
} from "../../../services/baseQuery";
import { projectStatus } from "../../../utils";

export default function CustomerProfileScreen() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const sidebar = useSelector((state) => state.sidebar);
  const [activeTab, setActiveTab] = useState("POSTED");

  const {
    isLoading,
    isError,
    data: customerData,
    error,
  } = useFetchCustomerByIdQuery({ customerId });

  const { isLoading: projectsLoading, data: customerProjects } =
    useFetchCustomerProjectsQuery({ customerId });

  if (isLoading || projectsLoading) {
    return (
      <div className="MainContainer">
        <SideBar />
        <div
          style={{ width: sidebar.expand ? "84vw" : "95vw" }}
          className="ScreenContainer"
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "14vh",
            }}
          >
            <div style={{ width: "20vw" }}>
              <OvalLoader visible={true} color="#3366CC" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError || !customerData) {
    return (
      <div className="MainContainer">
        <SideBar />
        <div
          style={{ width: sidebar.expand ? "84vw" : "95vw" }}
          className="ScreenContainer"
        >
          <div className="errorContainer">
            <h2>Error loading customer data</h2>
            <p>{error?.error || "Customer not found"}</p>
            <button
              className="backButton"
              onClick={() => navigate("/allCustomers")}
            >
              Back to All Customers
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Filter projects by status
  const postedProjects =
    customerProjects?.filter(
      (project) =>
        project.status === projectStatus.POSTED ||
        project.status === projectStatus.ADMIN_DECLINED
    ) || [];

  const activeProjects =
    customerProjects?.filter(
      (project) => project.status === projectStatus.ACTIVE
    ) || [];

  const completedProjects =
    customerProjects?.filter(
      (project) => project.status === projectStatus.COMPLETE
    ) || [];

  // Helper function to safely format date
  const formatDate = (timestamp) => {
    if (!timestamp) return "-";
    try {
      return timestamp.toDate().toLocaleDateString();
    } catch (error) {
      return "-";
    }
  };

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer customerProfileScreenContainr"
      >
        {/* Upper search bar */}
        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              <img
                onClick={() => navigate(-1)}
                src={require("../../../assets/back_bold.png")}
                alt="back"
                className="merchantProfileBack"
              />
            </div>
          </div>
        </div>

        <div className="merchantProfileInnerContainer">
          <div className="merchantInfoOuterContainer merchantProfileInnerHeader">
            <div className="customerProfileImageContainer">
              {customerData.displayImage ? (
                <img
                  src={customerData.displayImage}
                  alt="Customer"
                  className="customerProfileImage"
                />
              ) : (
                <div className="customerProfileImagePlaceholder">
                  {customerData.displayName?.charAt(0) || "C"}
                </div>
              )}
            </div>
            <div className="merchantProfileHeader">
              <div className="merchantProfileName">
                {customerData.displayName || "No Name"}
              </div>
            </div>
          </div>

          <div className="merchantInfoOuterContainer">
            <div className="merchantInfoInnerContainer">
              <div className="merchantInfoHeader">Display Name :</div>
              <div className="merchantInfo">
                {customerData.displayName || "-"}
              </div>
            </div>
            <div className="merchantInfoInnerContainer">
              <div className="merchantInfoHeader">Email :</div>
              <div className="merchantInfo">{customerData.email || "-"}</div>
            </div>
          </div>

          <div className="merchantInfoOuterContainer">
            <div className="merchantInfoInnerContainer">
              <div className="merchantInfoHeader">Phone Number :</div>
              <div className="merchantInfo">
                {customerData.phoneNumber || "-"}
              </div>
            </div>
            <div className="merchantInfoInnerContainer">
              <div className="merchantInfoHeader">Agreed to Terms :</div>
              <div className="merchantInfo">
                {customerData.agreedTermsAndConditions ? "Yes" : "No"}
              </div>
            </div>
          </div>

          {customerData.address && (
            <>
              <div className="merchantInfoOuterContainer">
                <div className="merchantInfoInnerContainer">
                  <div className="merchantInfoHeader">Area :</div>
                  <div className="merchantInfo">
                    {customerData.address.area || "-"}
                  </div>
                </div>
                <div className="merchantInfoInnerContainer">
                  <div className="merchantInfoHeader">City :</div>
                  <div className="merchantInfo">
                    {customerData.address.city || "-"}
                  </div>
                </div>
              </div>

              <div className="merchantInfoOuterContainer">
                <div className="merchantInfoInnerContainer">
                  <div className="merchantInfoHeader">House No :</div>
                  <div className="merchantInfo">
                    {customerData.address.houseNo || "-"}
                  </div>
                </div>
                <div className="merchantInfoInnerContainer">
                  <div className="merchantInfoHeader">Pincode :</div>
                  <div className="merchantInfo">
                    {customerData.address.pincode || "-"}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Customer Projects Section */}
          <div className="customerProjectsSection">
            <h3 className="sectionTitle">Customer Projects</h3>

            <div className="projectStatusTab">
              <div
                className={
                  activeTab === projectStatus.POSTED
                    ? "projectCategoryButton activeProjectCategoryButton"
                    : "projectCategoryButton projectCategoryButtonInactive"
                }
                onClick={() => setActiveTab(projectStatus.POSTED)}
              >
                Posted ({postedProjects.length})
              </div>
              <div
                className={
                  activeTab === projectStatus.ACTIVE
                    ? "projectCategoryButton activeProjectCategoryButton"
                    : "projectCategoryButton projectCategoryButtonInactive"
                }
                onClick={() => setActiveTab(projectStatus.ACTIVE)}
              >
                Active ({activeProjects.length})
              </div>
              <div
                className={
                  activeTab === projectStatus.COMPLETE
                    ? "projectCategoryButton activeProjectCategoryButton"
                    : "projectCategoryButton projectCategoryButtonInactive"
                }
                onClick={() => setActiveTab(projectStatus.COMPLETE)}
              >
                Completed ({completedProjects.length})
              </div>
            </div>

            {/* Project List */}
            <div className="customerProjectsList">
              {activeTab === projectStatus.POSTED && (
                <div className="projectsTable">
                  {postedProjects.length > 0 ? (
                    <table className="customTable">
                      <thead>
                        <tr>
                          <th>Project ID</th>
                          <th>Project Title</th>
                          <th>Budget</th>
                          <th>Categories</th>
                          <th>Created On</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {postedProjects.map((project) => (
                          <tr key={project.id}>
                            <td>{project.projectId}</td>
                            <td>{project.title || "-"}</td>
                            <td>
                              {project.budget
                                ? `${project.budget.from} - ${project.budget.to} SAR`
                                : "-"}
                            </td>
                            <td>
                              {project.category &&
                              project.category.length > 0 ? (
                                <div className="merchant-categories">
                                  {project.category.map((category, index) => (
                                    <span
                                      key={index}
                                      className="merchant-category-badge"
                                    >
                                      {category.name}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{formatDate(project.createdAt)}</td>
                            <td>
                              <span
                                className={`status-badge status-${project.status.toLowerCase()}`}
                              >
                                {project.status}
                              </span>
                            </td>
                            <td>
                              <button
                                className="viewButton"
                                onClick={() =>
                                  navigate(
                                    `/project-details/${project.id}/POSTED`
                                  )
                                }
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="noProjectsMessage">
                      No posted projects found
                    </div>
                  )}
                </div>
              )}

              {activeTab === projectStatus.ACTIVE && (
                <div className="projectsTable">
                  {activeProjects.length > 0 ? (
                    <table className="customTable">
                      <thead>
                        <tr>
                          <th>Project ID</th>
                          <th>Project Title</th>
                          <th>Price Finalized</th>
                          <th>Categories</th>
                          <th>Started On</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {activeProjects.map((project) => (
                          <tr key={project.id}>
                            <td>{project.projectId}</td>
                            <td>{project.title || "-"}</td>
                            <td>
                              {project.priceFinalized
                                ? `${project.priceFinalized} SAR`
                                : "-"}
                            </td>
                            <td>
                              {project.category &&
                              project.category.length > 0 ? (
                                <div className="merchant-categories">
                                  {project.category.map((category, index) => (
                                    <span
                                      key={index}
                                      className="merchant-category-badge"
                                    >
                                      {category.name}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{formatDate(project.projectStartedOn)}</td>
                            <td>
                              <button
                                className="viewButton"
                                onClick={() =>
                                  navigate(
                                    `/project-details/${project.id}/ACTIVE`
                                  )
                                }
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="noProjectsMessage">
                      No active projects found
                    </div>
                  )}
                </div>
              )}

              {activeTab === projectStatus.COMPLETE && (
                <div className="projectsTable">
                  {completedProjects.length > 0 ? (
                    <table className="customTable">
                      <thead>
                        <tr>
                          <th>Project ID</th>
                          <th>Project Title</th>
                          <th>Price Finalized</th>
                          <th>Categories</th>
                          <th>Completed On</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {completedProjects.map((project) => (
                          <tr key={project.id}>
                            <td>{project.projectId}</td>
                            <td>{project.title || "-"}</td>
                            <td>
                              {project.priceFinalized
                                ? `${project.priceFinalized} SAR`
                                : "-"}
                            </td>
                            <td>
                              {project.category &&
                              project.category.length > 0 ? (
                                <div className="merchant-categories">
                                  {project.category.map((category, index) => (
                                    <span
                                      key={index}
                                      className="merchant-category-badge"
                                    >
                                      {category.name}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{formatDate(project.completedOn)}</td>
                            <td>
                              <button
                                className="viewButton"
                                onClick={() =>
                                  navigate(
                                    `/project-details/${project.id}/COMPLETE`
                                  )
                                }
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="noProjectsMessage">
                      No completed projects found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
